<div class="visual-sales-tool-container__body visual-sales-tool-container__body--{{ template }}">
  <div class="visual-sales-tool__disclaimer-container" *ngIf="showRidersDisclaimer">
    <p class="visual-sales-tool__rider-disclaimer">
      This visualization does not include the premium cost of some riders (Guaranteed Insurability and Renewable Term).
      To see these costs, please view the Basic Illustration.
    </p>
  </div>
  <div *ngIf="template === 'client'" class="visual-sales-tool-container__caption">
    <h5 class="visual-sales-tool-container__subheading">
      By age
      <span class="visual-sales-tool-container__subheading-age">{{ age }}</span>
      , your policy values may be:
    </h5>
    <div class="visual-sales-tool-container__subheading-mark"></div>
  </div>
  <div class="visual-sales-tool">
    <div class="visual-sales-tool__header" *ngIf="vstData">
      <vst-label
        *ngFor="let label of labels"
        [key]="label"
        [label]="vstData[label].name"
        [value]="labelValues[label]"
        [display]="true"
      ></vst-label>
    </div>
    <div class="visual-sales-tool__chart-container">
      <vst-chart
        #vstchart
        (ageChange)="onAgeChange($event)"
        [conceptIllustration]="false"
        [initialAge]="age"
      ></vst-chart>
      <div class="visual-sales-tool__secondary" *ngIf="vstData">
        <vst-label
          *ngFor="let label of optionalLabels"
          [key]="label"
          [label]="vstData[label].name"
          [value]="labelValues[label]"
          [display]="true"
          (displayLabel)="updateLabels($event)"
        ></vst-label>
      </div>
    </div>
    <ng-container *ngIf="template === 'client'">
      <p class="visual-sales-tool__info">
        Your Dividend Option is
        <span class="visual-sales-tool__info-variable">{{ vstClientInfo.dividendOption }}</span>
        <!--and Risk Class is
        <span class="visual-sales-tool__info-variable">{{ vstClientInfo.rateClass }}</span
        >-->
        .
      </p>
    </ng-container>
  </div>
</div>
